module.exports = __webpack_public_path__ + "static/media/153-cuba.6114d736.svg";